/**
 * Picks the values a config form should start from when it mounts: the user's latest edits if there
 * are any, otherwise the saved starting values. Edits are kept in formRendererValues and the saved
 * starting point in formRendererInitialValues, so this is what lets an unmounted form come back intact.
 */
export function formSeedValues(
  edited: Record<string, any>,
  initial: Record<string, any>,
): Record<string, any> {
  return Object.keys(edited).length > 0 ? edited : initial;
}

/** Recursively decode HTML entities that FormRenderer encodes in string values (e.g. &quot; → "). */
export function decodeHtmlEntities(value: any): any {
  if (typeof value === 'string') {
    return value
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g,  "'")
      .replace(/&amp;/g,  '&')
      .replace(/&lt;/g,   '<')
      .replace(/&gt;/g,   '>');
  }
  if (Array.isArray(value)) return value.map(decodeHtmlEntities);
  if (value && typeof value === 'object') {
    const out: Record<string, any> = {};
    for (const k of Object.keys(value)) out[k] = decodeHtmlEntities(value[k]);
    return out;
  }
  return value;
}
